import { reduce } from "lodash-es";
import { IDimensions } from "Venues/types";

export const hasDimensions = (dimensions?: IDimensions) =>
  reduce(
    dimensions,
    (hasDimension, dimension) => {
      if (dimension !== undefined && dimension !== null) return true;
      return hasDimension;
    },
    false
  );
